import React, { useState, useEffect } from "react";
import Socket from "socket";
import _ from "lodash";

import BeforeActionCall from "../components/BeforeActionCall";
import AfterActionCall from "../components/AfterActionCall";

const Guessing = ({
  word,
  roomId,
  isGuesser,
  mobile_app,
  right_words,
  skipped_words,
  category_image,
  guessing_params,
  current_category,
}) => {
  const [scorerName, setScorerName] = useState("");
  const [totMessage, setTotMessage] = useState("");

  useEffect(() => {
    return Socket.addListener("tot-skipped-scored", handle_score_skip);
  }, []);

  const handle_score_skip = (res) => {
    setScorerName(res.display_name);
    setTotMessage(res.message);
  };

  return totMessage === "" ? (
    <BeforeActionCall
      word={word}
      roomId={roomId}
      isGuesser={isGuesser}
      mobile_app={mobile_app}
      right_words={right_words}
      skipped_words={skipped_words}
      category_image={category_image}
      guessing_params={guessing_params}
      current_category={current_category}
    />
  ) : (
    <AfterActionCall
      isGuesser={isGuesser}
      scorerName={scorerName}
      setTotMessage={setTotMessage}
      guessing_params={guessing_params}
      skipped={totMessage === "Skipped"}
    />
  );
};

export default Guessing;
